import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateRiesgoEmbarazoLactanciaByID = () => {
  const [loadingUpdateRiesgoEmbarazoLactanciaById, setLoadingCreateRiesgoEmbarazoLactancia] = useState(false);
  const [successUpdateRiesgoEmbarazoLactanciaById, setSuccessCreateRiesgoEmbarazoLactancia] = useState(false);
  const [errorUpdateRiesgoEmbarazoLactanciaById, setErrorCreateRiesgoEmbarazoLactancia] = useState(null);
  const [dataUpdateRiesgoEmbarazoLactanciaById, setDataRiesgoEmbarazoLactancia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateRiesgoEmbarazoLactanciaById = async (userId:string, formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateRiesgoEmbarazoLactancia(true);
    setSuccessCreateRiesgoEmbarazoLactancia(false);
    setErrorCreateRiesgoEmbarazoLactancia(null);

    apiRecord.updateSolicitudReconocimientoRELByID(userId, formId, data).then((res: any) => {
      setLoadingCreateRiesgoEmbarazoLactancia(false);
      setSuccessCreateRiesgoEmbarazoLactancia(true);
      setDataRiesgoEmbarazoLactancia(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateRiesgoEmbarazoLactancia(false);
      setErrorCreateRiesgoEmbarazoLactancia(err.response.data)
    })
  }

  return {
    updateRiesgoEmbarazoLactanciaById,
    loadingUpdateRiesgoEmbarazoLactanciaById,
    successUpdateRiesgoEmbarazoLactanciaById,
    errorUpdateRiesgoEmbarazoLactanciaById,
    dataUpdateRiesgoEmbarazoLactanciaById
  }

}

export default useUpdateRiesgoEmbarazoLactanciaByID;
